import React, { useMemo } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import type { TabItem, TabItemProps } from './index.type'
import Ripple from '@/components/Ripple'
const TabItem = React.memo<TabItemProps>(function TabItem({ item, isFocused, onClick }) {
  const { unActivedIcon, activedIcon, text } = item
  const color = isFocused ? '#006A00' : '#333333'

  return (
    <Ripple className=" rounded-2.5 flex-1">
      <div onClick={onClick} className=" rounded-2.5 flex-1 flex flex-col items-center justify-center pt-2 pb-4 px-1 min-h-[60px] transition-colors">
        <div className="w-6 h-6 mb-1 flex items-center justify-center bg-transparent">
          <img src={isFocused ? activedIcon : unActivedIcon} alt="" />
        </div>
        <span
          className="text-xs font-medium bg-transparent"
          style={{ color }}
        >
          {text}
        </span>
      </div>
    </Ripple>
  )
})

export default function TabsLayout() {
  const { t } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()

  const items = useMemo<TabItem[]>(
    () => ([
      {
        unActivedIcon: '/icon/tab-bar1.svg',
        activedIcon: '/icon/tab-bar1-active.svg',
        text: t('首页'),
        href: '/home'
      },
      {
        unActivedIcon: '/icon/tab-bar2.svg',
        activedIcon: '/icon/tab-bar2-active.svg',
        text: t('账户'),
        href: '/account'
      },
      {
        unActivedIcon: '/icon/tab-bar3.svg',
        activedIcon: '/icon/tab-bar3-active.svg',
        text: t('卡片'),
        href: '/card'
      },
      {
        unActivedIcon: '/icon/tab-bar4.svg',
        activedIcon: '/icon/tab-bar4-active.svg',
        text: t('我的'),
        href: '/my'
      },
    ]),
    [t]
  )

  const TabItems = useMemo(
    () => items.map((item, index) => {
      const isFocused = location.pathname === item.href

      return (
        <TabItem
          key={index}
          item={item}
          isFocused={isFocused}
          onClick={() => navigate(item.href)}
        />
      )
    }),
    [items, location.pathname, navigate]
  )

  return (
    <div className="bg-white h-full">
      {/* Main Content Area */}
      <Outlet />
      {/* Bottom Tab Bar */}
      <div className="flex w-full fixed bottom-0 left-0 right-0 z-2 bg-white border-t border-gray-200 safe-area-bottom h-17 max-w-750px translate-x-[-50%] left-1/2">
        {TabItems}
      </div>
    </div>
  )
}